import { inject, Injectable, signal } from '@angular/core';
import { CompaniesDataService } from '@app/shared/services/companies-data.service';
import { Cooperation } from '@app/shared/types/models/cooperation/cooperation.model';
import { cooperationStatusFromApi } from '../dtos/cooperation/cooperation-status.enum';
import { CooperationDTO } from '../dtos/cooperation/cooperation.dto';
import { AbstractFactory } from './abstract.factory';

@Injectable({ providedIn: 'root' })
export class CooperationFactory extends AbstractFactory<CooperationDTO, Cooperation> {
  private readonly companiesDataService = inject(CompaniesDataService);

  public produce(item: CooperationDTO): Cooperation {
    return new Cooperation({
      id: item.id,
      description: item.description,
      status: cooperationStatusFromApi(item.status),
      requestorCompany: item.requestor ? this.companiesDataService.getById(item.requestor.id) : signal(undefined),
      receipientCompany: item.recipient ? this.companiesDataService.getById(item.recipient.id) : signal(undefined)
    });
  }
}
